<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2m2QJG/tc-custom/9780253004451.jpg?1736610487481" alt="This image is the cover for the book Logic, Studies in Continental Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Logic, Studies in Continental Thought
      </h1>
      <p class="bookDescription body article font2">
        <b>Heidegger’s radical thinking on the meaning of truth in a “clear and comprehensive critical edition” (<i>Philosophy in Review</i>).</b><br/>  <br/> Martin Heidegger’s 1925–26 lectures on truth and time provided much of the basis for his momentous work, <i>Being and Time</i>. Not published until 1976—three months before Heidegger’s death—as volume 21 of his Complete Works, it is nonetheless central to Heidegger’s overall project of reinterpreting Western thought in terms of time and truth.<br/>  <br/> The text shows the degree to which Aristotle underlies Heidegger’s hermeneutical theory of meaning. It also contains Heidegger’s first published critique of Husserl and takes major steps toward establishing the temporal bases of logic and truth. Thomas Sheehan’s elegant and insightful translation offers English-speaking readers access to this fundamental text for the first time.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martin Heidegger, Thomas Sheehan
      </h2>
      
      <p class="authorDescription body article">Heidegger&rsquo;s contribution to the growth and development of National Socialism was immense. In this small anthology, Dr. Runes endeavors to point to the utter confusion Heidegger created by drawing, for political and social application of his own existentialism and metaphysics, upon the decadent and repulsive brutalization of Hitlerism.<BR /><BR /> Martin Heidegger was a philosopher most known for his contributions to German phenomenological and existential thought. Heidegger was born in rural Messkirch in 1889 to Catholic parents. While studying philosophy and mathematics at Albert-Ludwig University in Freiburg, Heidegger became the assistant for the philosopher Edmund Husserl. Influenced by Husserl, Kierkegaard, and Nietzsche, Heidegger wrote extensively on the quality of Being, including his Opus <I>Being and Time</I>. He served as professor of philosophy at Albert-Ludwig University and taught there during the war. In 1933, Heidegger joined the National Socialist German Worker&rsquo;s (or Nazi) Party and expressed his support for Hitler in several articles and speeches. After the war, his support for the Nazi party came under attack, and he was tried as a sympathizer. He was able to return to Albert Ludwig University, however, and taught there until he retired. Heidegger continued to lecture until his death in 1973.&#160;<br clear="all" /><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f6c9602